// @flow

export default {
  wizard: {
    next: 'Prochain',
    back: 'Retour',
    skip: 'Sauter',
    sort: 'Trier',
    sorting: {
      'utility:desc': 'Meilleur résultat',
      'price:asc': 'Prix ascendant',
      'price:desc': 'Prix descendant',
      'created_at:desc': 'Plus récent',
      'customer_rating:desc': 'Évaluation du client'
    },
    clickToAddFiles: 'Cliquez pour ajouter vos fichiers ou déposez-les ici.',
    searchFor: 'Rechercher ...',
    noSearchResults: 'Malheureusement, nous n\'avons trouvé aucune option appropriée. Veuillez rechercher à nouveau.',
    loadMoreAnswerOptions: 'Aucune option appropriée ici? Affichez toutes les options.',
    noRecommendationDescription: 'Oh non, malheureusement, nous n\'avons pu trouver aucun produit qui répond à vos besoins.',
    noRecommendationDescription2: 'Veuillez redémarrer le conseiller produit.',
    noRecommendationRestartButtonTitle: 'Redémarrage',
    noRecommendationCloseButtonTitle: 'Fermer',
    removeFile: 'Supprimer le fichier'
  },
  chatbot: {
    selectAll: 'Tout sélectionner',
    none: 'Aucun',
    confirmButton: 'Confirmer',
    customerServiceInputPlaceholder: 'Écrivez un message ...',
    you: 'Toi',
    restart: 'Recommencer',
    close: 'Fermer',
    send: 'Envoyer',
    supportChat: 'Chat de support',
    honeypot: 'Veuillez laisser ce champ vide',
    scrollToTheLatestMessage: 'Faire défiler jusqu\'au dernier message',
    removeFile: 'Supprimer le fichier'
  },
  product: {
    loadMore: 'Chargez plus de produits',
    badgeTitle: 'Notre recommandation',
    ctaButtonTitle: 'Découvrir le produit',
    matchingPanelTitle: 'Adapté à vos besoins',
    bestFit: 'Meilleur ajustement',
    bestPrice: 'Meilleur prix',
    bestFitForPrice: 'Meilleur prix de l\'ajustement',
    addToCartError: 'Ajouter à CART n\'a pas réussi. Veuillez réessayer',
    addRoutineToCart: 'Ajouter une routine au panier',
    explanationHeader: 'Plus d\'informations sur les produits:',
    emptyRoutineItem: 'Malheureusement, il n\'y a pas de produit dans cette catégorie qui correspond à vos préférences.'
  },
  tabBar: {
    chat: 'Chat',
    productAdvisor: 'Conseiller produit'
  },
  recommender: {
    answerOptionLeadsToNoRecommendation: 'Malheureusement, cette option ne conduirait à aucun produit souhaité. Vous pouvez modifier votre préférence dans les étapes précédentes pour activer l\'option.'
  }
}
